theme.columnCountSwitcher = (function(){
  const selectors = {
    section: '.shopify-section',
    productGrid: '.product-grid',
    switcher: '.column-count-switcher',
    button: '.column-count-switcher__button',
    storageKey: 'soar:column-count'
  }

  const init = () => {
    let switchers = document.querySelectorAll(selectors.switcher);
    if(switchers) switchers.forEach(switcher => initSwitcher(switcher));
  }

  const setColumns = (columnCount, productGrid) => {
    productGrid.setAttribute('data-columns-desktop', columnCount);
    localStorage.setItem(selectors.storageKey, columnCount);
  }
  
  const setActiveButton = (activeButton, switcher) => {
    let buttons = switcher.querySelectorAll(selectors.button);
    buttons.forEach(b => b.classList.remove('active'));
    activeButton.classList.add('active');
  }

  const initSwitcher = (switcher) => {
    let buttons = switcher.querySelectorAll(selectors.button);
    let activeButton = switcher.querySelector(`${selectors.button}.active`);
    let columnCount;
    let productGrid = activeButton.closest(selectors.section).querySelector(selectors.productGrid);

    if(!localStorage.getItem(selectors.storageKey)){
      columnCount = parseInt(activeButton.dataset.columnCount);
    }else{
      columnCount = parseInt(localStorage.getItem(selectors.storageKey));
      let activeButton = document.querySelector(`${selectors.button}[data-column-count="${columnCount}"]`);
      setActiveButton(activeButton, switcher);
    }
    
    setColumns(columnCount, productGrid);

    if(buttons.length){
      buttons.forEach(button => {
        button.addEventListener('click', function(e){          
          let clickedButton = e.target.closest(selectors.button);
          setActiveButton(clickedButton, switcher);

          let columnCount = parseInt(clickedButton.dataset.columnCount);
          let productGrid = clickedButton.closest(selectors.section).querySelector(selectors.productGrid);

          setColumns(columnCount, productGrid);
        });
      });
    }
  }

  return {
    init,
    selectors
  }
})();